import React from 'react'
import TabletMain from '../components/WireframeTabletCs/TabletMain'

const Home = () => {
  return (
    <div><TabletMain /></div>
  )
}

export default Home